<template>
    <div class="bui-container">
        <div class="loading-img"></div>
    </div>
</template>
<script>
export default {
    name: "loading",
}
</script>
<style lang="scss" scoped>
    .bui-container {
        width: 100%;
        height: 100%;
        background-color: rgba(255,255,255,0.7);
        .loading-img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100px;
            height: 100px;
            background: url("./imgs/loading.svg") center top no-repeat;
            background-size: contain;
        }
    }
</style>